var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgDashboard = function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.033 2.016C22.033.938 21.095 0 20.017 0H2.016C.938 0 0 .938 0 2.016v12c0 1.078.938 1.969 2.016 1.969h5.016v2.016h7.969v-2.016h5.016a1.981 1.981 0 0 0 1.969-1.969l.047-12Zm-2.016 12v-12h-18v12h18ZM6.001 6.985V5.016H4.032v1.969h1.969Zm0 4.031V9H4.032v2.016h1.969Zm12-2.016v2.016H7.032V9h10.969Zm0-2.015V5.016H7.032v1.969h10.969Z",
    fill: "currentColor"
  })));
};
export default SvgDashboard;